<template>
  <div class='tooltip-wrapper rounded-2' :class="{clicked}" @click="clicked = true" v-click-outside="handleClick">
    <div class='d-flex align-items-center flex-column'>
      <slot name="content">
      </slot>

      <div class="tooltip-container">
        <slot name="tooltip-content">
          <div class='tooltip-container-message' >
            <span>{{ $t('Please note that available days are updated.')}}</span>
            <span>{{ $t('Check them out.')}}</span>
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AsahiInfoToolTip',
  data () {
    return {
      clicked: false
    }
  },
  methods: {
    handleClick () {
      this.clicked = false
    }
  }
})
</script>

<style scoped lang='scss'>
.tooltip-wrapper {
  position: relative;
}
.tooltip-container {
  padding:24px 34px;
  position: absolute;
  top: 35px;
  background-color: $primary-dark-green;
  z-index: 1000;
  align-items: flex-start;
  box-shadow: 0px 4px 12px 0px $box-shadow-color;
  display: none;
  max-width: 368px;
  color: $primary-white;
  border-radius: 10px;

  .tooltip-container-message,
  .tooltip-container-title{
    font-size: 14px;
    line-height: 1.25;
    text-align: left;
  }

  .tooltip-container-message{
    font-weight: 300;
    width: 200px;
    span {
      display: inline-block;
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid $primary-dark-green;
  }
}

.tooltip-wrapper:hover .tooltip-container {
  display: block;
}
@media screen and (max-width: $breakpoint-sm) {
  .tooltip-wrapper.clicked .tooltip-container {
    display: block;
  }
  .tooltip-container {
    top: auto;
    left: 10px;
    bottom: 30px;

    &::before {
      display: none;
    }
    &::after {
      content: '';
      position: absolute;
      top: auto;
      bottom: -8px;
      left: 5%;
      transform: translateX(-50%);
      width: 0;
      height: 0;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid $primary-dark-green;
    }
  }
}
</style>
